// Price transparency / Catalyst configuration.
//
// Catalyst is Clariti Health's consumer-facing estimator, provisioned for us by
// HST Pathways. Until HST issues Lake Lucien's org key the tool has nothing to
// calculate — we have no negotiated payer contracts yet — so the estimate CTA
// points at the business office rather than at a dead link.
//
// To go live: paste the org key below. The Price Transparency page switches the
// button over to the live estimator on its own; nothing else needs editing.
export const CATALYST_ORG_KEY = '';

export const CATALYST_URL = CATALYST_ORG_KEY
  ? `https://www.clariti-health.com/csp/clariti/QuotableService.csp?orgKey=${CATALYST_ORG_KEY}&quotablecategoryId=1`
  : null;

export const isEstimatorLive = Boolean(CATALYST_URL);

// Every estimate CTA across the site points here; the page itself owns the
// decision of where the button goes. One destination, one place to swap.
export const PRICE_TRANSPARENCY_PATH = '/price-transparency';
